// extracted by mini-css-extract-plugin
export default {"diff":"Diff_diff__bP+GU"};